// draftManager.js
// Manages draft state, player generation, and scoring logic.
// Currently uses mock player data — replace generatePlayers() with
// a Firestore fetch when ready to connect the real player database.

// ─── Sport Configurations ────────────────────────────────────────────────────

export const SPORT_CONFIG = {
  football:   { color: "#00b04f", positions: ["QB","RB","TE","WR","WR","OL","OL","DL","ED","LB","LB","CB","DB","S"] },
  baseball:   { color: "#db2626", positions: ["C","1B","2B","3B","SS","LF","CF","RF","DH","SP","SP","RP"] },
  basketball: { color: "#ff8c00", positions: ["PG","SG","SF","PF","C","G","G","F","F","C"] },
  hockey:     { color: "#0da6e8", positions: ["LW","C","RW","LD","RD","G","LW","C","RW","LD","RD"] },
  soccer:     { color: "#1a66e6", positions: ["GK","DEF","DEF","DEF","DEF","MID","MID","MID","W","W","ST"] },
};

// ─── Mock Player Pools ───────────────────────────────────────────────────────
// Shape mirrors Firestore player documents: { name, city, jerseyNumber, year, overallRating, position }
// TODO: Replace generatePlayers() with Firestore query when connecting real data.

const MOCK_PLAYERS = {
  football: [
    { name:"PATRICK MAHOMES",city:"KANSAS CITY",jerseyNumber:15,year:2023,overallRating:99,position:"QB" },
    { name:"LAMAR JACKSON",city:"BALTIMORE",jerseyNumber:8,year:2023,overallRating:97,position:"QB" },
    { name:"JOE BURROW",city:"CINCINNATI",jerseyNumber:9,year:2023,overallRating:93,position:"QB" },
    { name:"JOSH ALLEN",city:"BUFFALO",jerseyNumber:17,year:2023,overallRating:96,position:"QB" },
    { name:"JALEN HURTS",city:"PHILADELPHIA",jerseyNumber:1,year:2023,overallRating:94,position:"QB" },
    { name:"TRAVIS KELCE",city:"KANSAS CITY",jerseyNumber:87,year:2023,overallRating:97,position:"TE" },
    { name:"MARK ANDREWS",city:"BALTIMORE",jerseyNumber:89,year:2023,overallRating:90,position:"TE" },
    { name:"SAM LAPORTA",city:"DETROIT",jerseyNumber:86,year:2023,overallRating:81,position:"TE" },
    { name:"DARREN WALLER",city:"NEW YORK",jerseyNumber:83,year:2022,overallRating:85,position:"TE" },
    { name:"TYREEK HILL",city:"MIAMI",jerseyNumber:10,year:2023,overallRating:98,position:"WR" },
    { name:"JUSTIN JEFFERSON",city:"MINNESOTA",jerseyNumber:18,year:2023,overallRating:99,position:"WR" },
    { name:"DAVANTE ADAMS",city:"LAS VEGAS",jerseyNumber:17,year:2023,overallRating:93,position:"WR" },
    { name:"STEFON DIGGS",city:"BUFFALO",jerseyNumber:14,year:2023,overallRating:91,position:"WR" },
    { name:"CEE DEE LAMB",city:"DALLAS",jerseyNumber:88,year:2023,overallRating:96,position:"WR" },
    { name:"COOPER KUPP",city:"LOS ANGELES",jerseyNumber:10,year:2023,overallRating:88,position:"WR" },
    { name:"CHRISTIAN MCCAFFREY",city:"SAN FRANCISCO",jerseyNumber:23,year:2023,overallRating:99,position:"RB" },
    { name:"DERRICK HENRY",city:"TENNESSEE",jerseyNumber:22,year:2022,overallRating:94,position:"RB" },
    { name:"NICK CHUBB",city:"CLEVELAND",jerseyNumber:24,year:2022,overallRating:92,position:"RB" },
    { name:"AUSTIN EKELER",city:"LOS ANGELES",jerseyNumber:30,year:2022,overallRating:88,position:"RB" },
    { name:"TRENT WILLIAMS",city:"SAN FRANCISCO",jerseyNumber:71,year:2023,overallRating:99,position:"OT" },
    { name:"LANE JOHNSON",city:"PHILADELPHIA",jerseyNumber:65,year:2023,overallRating:96,position:"OT" },
    { name:"QUENTON NELSON",city:"INDIANAPOLIS",jerseyNumber:56,year:2022,overallRating:95,position:"OG" },
    { name:"ZAK MARTIN",city:"DALLAS",jerseyNumber:70,year:2022,overallRating:90,position:"OG" },
    { name:"CREED HUMPHREY",city:"KANSAS CITY",jerseyNumber:52,year:2023,overallRating:93,position:"C" },
    { name:"MICAH PARSONS",city:"DALLAS",jerseyNumber:11,year:2023,overallRating:99,position:"ED" },
    { name:"MYLES GARRETT",city:"CLEVELAND",jerseyNumber:95,year:2023,overallRating:97,position:"ED" },
    { name:"MAXX CROSBY",city:"LAS VEGAS",jerseyNumber:98,year:2023,overallRating:94,position:"ED" },
    { name:"AARON DONALD",city:"LOS ANGELES",jerseyNumber:99,year:2022,overallRating:99,position:"DL" },
    { name:"CHRIS JONES",city:"KANSAS CITY",jerseyNumber:95,year:2023,overallRating:95,position:"DL" },
    { name:"DEXTER LAWRENCE",city:"NEW YORK",jerseyNumber:97,year:2023,overallRating:91,position:"DL" },
    { name:"FRED WARNER",city:"SAN FRANCISCO",jerseyNumber:54,year:2023,overallRating:96,position:"LB" },
    { name:"BOBBY WAGNER",city:"LOS ANGELES",jerseyNumber:54,year:2022,overallRating:90,position:"LB" },
    { name:"DEMARIO DAVIS",city:"NEW ORLEANS",jerseyNumber:56,year:2022,overallRating:88,position:"LB" },
    { name:"SAUCE GARDNER",city:"NEW YORK",jerseyNumber:1,year:2023,overallRating:96,position:"CB" },
    { name:"JALEN RAMSEY",city:"LOS ANGELES",jerseyNumber:5,year:2022,overallRating:95,position:"CB" },
    { name:"STEPHON GILMORE",city:"DALLAS",jerseyNumber:21,year:2022,overallRating:87,position:"CB" },
    { name:"DERWIN JAMES",city:"LOS ANGELES",jerseyNumber:3,year:2023,overallRating:93,position:"S" },
    { name:"TYRANN MATHIEU",city:"NEW ORLEANS",jerseyNumber:32,year:2022,overallRating:88,position:"S" },
    { name:"JESSIE BATES",city:"ATLANTA",jerseyNumber:30,year:2023,overallRating:87,position:"S" },
    { name:"BUDDA BAKER",city:"ARIZONA",jerseyNumber:3,year:2022,overallRating:91,position:"DB" },
  ],
  baseball: [
    { name:"SHOHEI OHTANI",city:"LOS ANGELES",jerseyNumber:17,year:2023,overallRating:99,position:"DH" },
    { name:"FREDDIE FREEMAN",city:"LOS ANGELES",jerseyNumber:5,year:2023,overallRating:93,position:"1B" },
    { name:"PETE ALONSO",city:"NEW YORK",jerseyNumber:20,year:2023,overallRating:88,position:"1B" },
    { name:"JOSE ALTUVE",city:"HOUSTON",jerseyNumber:27,year:2023,overallRating:90,position:"2B" },
    { name:"MARCUS SEMIEN",city:"TEXAS",jerseyNumber:2,year:2023,overallRating:88,position:"2B" },
    { name:"MANNY MACHADO",city:"SAN DIEGO",jerseyNumber:13,year:2023,overallRating:91,position:"3B" },
    { name:"NOLAN ARENADO",city:"ST. LOUIS",jerseyNumber:28,year:2023,overallRating:92,position:"3B" },
    { name:"FRANCISCO LINDOR",city:"NEW YORK",jerseyNumber:12,year:2023,overallRating:91,position:"SS" },
    { name:"TREA TURNER",city:"PHILADELPHIA",jerseyNumber:7,year:2023,overallRating:90,position:"SS" },
    { name:"JUAN SOTO",city:"NEW YORK",jerseyNumber:22,year:2023,overallRating:97,position:"LF" },
    { name:"YORDAN ALVAREZ",city:"HOUSTON",jerseyNumber:44,year:2023,overallRating:96,position:"LF" },
    { name:"MIKE TROUT",city:"LOS ANGELES",jerseyNumber:27,year:2023,overallRating:97,position:"CF" },
    { name:"JULIO RODRIGUEZ",city:"SEATTLE",jerseyNumber:44,year:2023,overallRating:92,position:"CF" },
    { name:"AARON JUDGE",city:"NEW YORK",jerseyNumber:99,year:2023,overallRating:98,position:"RF" },
    { name:"KYLE TUCKER",city:"HOUSTON",jerseyNumber:30,year:2023,overallRating:91,position:"RF" },
    { name:"WILL SMITH",city:"LOS ANGELES",jerseyNumber:16,year:2023,overallRating:88,position:"C" },
    { name:"GERRIT COLE",city:"NEW YORK",jerseyNumber:45,year:2023,overallRating:97,position:"SP" },
    { name:"SPENCER STRIDER",city:"ATLANTA",jerseyNumber:99,year:2023,overallRating:96,position:"SP" },
    { name:"ZACK WHEELER",city:"PHILADELPHIA",jerseyNumber:45,year:2023,overallRating:93,position:"SP" },
    { name:"FELIX BAUTISTA",city:"BALTIMORE",jerseyNumber:74,year:2023,overallRating:95,position:"RP" },
    { name:"RYAN HELSLEY",city:"ST. LOUIS",jerseyNumber:56,year:2023,overallRating:93,position:"RP" },
  ],
  basketball: [
    { name:"NIKOLA JOKIC",city:"DENVER",jerseyNumber:15,year:2024,overallRating:99,position:"C" },
    { name:"JOEL EMBIID",city:"PHILADELPHIA",jerseyNumber:21,year:2024,overallRating:97,position:"C" },
    { name:"BAM ADEBAYO",city:"MIAMI",jerseyNumber:13,year:2024,overallRating:90,position:"C" },
    { name:"LUKA DONCIC",city:"DALLAS",jerseyNumber:77,year:2024,overallRating:98,position:"PG" },
    { name:"STEPHEN CURRY",city:"GOLDEN STATE",jerseyNumber:30,year:2024,overallRating:96,position:"PG" },
    { name:"TRAE YOUNG",city:"ATLANTA",jerseyNumber:11,year:2024,overallRating:89,position:"PG" },
    { name:"TYRESE HALIBURTON",city:"INDIANA",jerseyNumber:0,year:2024,overallRating:91,position:"PG" },
    { name:"DEVIN BOOKER",city:"PHOENIX",jerseyNumber:1,year:2024,overallRating:93,position:"SG" },
    { name:"DONOVAN MITCHELL",city:"CLEVELAND",jerseyNumber:45,year:2024,overallRating:92,position:"SG" },
    { name:"JAYLEN BROWN",city:"BOSTON",jerseyNumber:7,year:2024,overallRating:91,position:"SG" },
    { name:"LEBRON JAMES",city:"LOS ANGELES",jerseyNumber:23,year:2024,overallRating:97,position:"SF" },
    { name:"JAYSON TATUM",city:"BOSTON",jerseyNumber:0,year:2024,overallRating:96,position:"SF" },
    { name:"PAUL GEORGE",city:"PHILADELPHIA",jerseyNumber:8,year:2024,overallRating:88,position:"SF" },
    { name:"GIANNIS ANTETOKOUNMPO",city:"MILWAUKEE",jerseyNumber:34,year:2024,overallRating:98,position:"PF" },
    { name:"KEVIN DURANT",city:"PHOENIX",jerseyNumber:35,year:2024,overallRating:96,position:"PF" },
    { name:"PASCAL SIAKAM",city:"INDIANA",jerseyNumber:43,year:2024,overallRating:89,position:"PF" },
  ],
  hockey: [
    { name:"CONNOR MCDAVID",city:"EDMONTON",jerseyNumber:97,year:2024,overallRating:99,position:"C" },
    { name:"NATHAN MACKINNON",city:"COLORADO",jerseyNumber:29,year:2024,overallRating:98,position:"C" },
    { name:"LEON DRAISAITL",city:"EDMONTON",jerseyNumber:29,year:2024,overallRating:96,position:"C" },
    { name:"SIDNEY CROSBY",city:"PITTSBURGH",jerseyNumber:87,year:2024,overallRating:95,position:"C" },
    { name:"ALEX OVECHKIN",city:"WASHINGTON",jerseyNumber:8,year:2024,overallRating:93,position:"LW" },
    { name:"ARTEMI PANARIN",city:"NEW YORK",jerseyNumber:10,year:2024,overallRating:93,position:"LW" },
    { name:"KIRILL KAPRIZOV",city:"MINNESOTA",jerseyNumber:97,year:2024,overallRating:94,position:"LW" },
    { name:"NIKITA KUCHEROV",city:"TAMPA BAY",jerseyNumber:86,year:2024,overallRating:97,position:"RW" },
    { name:"DAVID PASTRNAK",city:"BOSTON",jerseyNumber:88,year:2024,overallRating:95,position:"RW" },
    { name:"MIKKO RANTANEN",city:"COLORADO",jerseyNumber:96,year:2024,overallRating:93,position:"RW" },
    { name:"CALE MAKAR",city:"COLORADO",jerseyNumber:8,year:2024,overallRating:98,position:"LD" },
    { name:"ROMAN JOSI",city:"NASHVILLE",jerseyNumber:59,year:2024,overallRating:93,position:"LD" },
    { name:"VICTOR HEDMAN",city:"TAMPA BAY",jerseyNumber:77,year:2024,overallRating:94,position:"RD" },
    { name:"ADAM FOX",city:"NEW YORK",jerseyNumber:23,year:2024,overallRating:93,position:"RD" },
    { name:"ANDREI VASILEVSKIY",city:"TAMPA BAY",jerseyNumber:88,year:2024,overallRating:95,position:"G" },
    { name:"IGOR SHESTERKIN",city:"NEW YORK",jerseyNumber:31,year:2024,overallRating:96,position:"G" },
    { name:"CONNOR HELLEBUYCK",city:"WINNIPEG",jerseyNumber:37,year:2024,overallRating:94,position:"G" },
  ],
  soccer: [
    { name:"LIONEL MESSI",city:"MIAMI",jerseyNumber:10,year:2024,overallRating:99,position:"ST" },
    { name:"ERLING HAALAND",city:"MANCHESTER",jerseyNumber:9,year:2024,overallRating:98,position:"ST" },
    { name:"KYLIAN MBAPPE",city:"MADRID",jerseyNumber:9,year:2024,overallRating:97,position:"ST" },
    { name:"VINICIUS JR",city:"MADRID",jerseyNumber:7,year:2024,overallRating:95,position:"W" },
    { name:"BUKAYO SAKA",city:"LONDON",jerseyNumber:7,year:2024,overallRating:92,position:"W" },
    { name:"PHIL FODEN",city:"MANCHESTER",jerseyNumber:47,year:2024,overallRating:93,position:"W" },
    { name:"KEVIN DE BRUYNE",city:"MANCHESTER",jerseyNumber:17,year:2024,overallRating:96,position:"MID" },
    { name:"JUDE BELLINGHAM",city:"MADRID",jerseyNumber:5,year:2024,overallRating:95,position:"MID" },
    { name:"PEDRI",city:"BARCELONA",jerseyNumber:8,year:2024,overallRating:91,position:"MID" },
    { name:"BERNARDO SILVA",city:"MANCHESTER",jerseyNumber:20,year:2024,overallRating:90,position:"MID" },
    { name:"VIRGIL VAN DIJK",city:"LIVERPOOL",jerseyNumber:4,year:2024,overallRating:93,position:"DEF" },
    { name:"RUBEN DIAS",city:"MANCHESTER",jerseyNumber:3,year:2024,overallRating:92,position:"DEF" },
    { name:"WILLIAM SALIBA",city:"LONDON",jerseyNumber:12,year:2024,overallRating:90,position:"DEF" },
    { name:"ANTONIO RUDIGER",city:"MADRID",jerseyNumber:22,year:2024,overallRating:88,position:"DEF" },
    { name:"TRENT ALEXANDER-ARNOLD",city:"LIVERPOOL",jerseyNumber:66,year:2024,overallRating:91,position:"DEF" },
    { name:"THIBAUT COURTOIS",city:"MADRID",jerseyNumber:1,year:2024,overallRating:94,position:"GK" },
    { name:"ALISSON BECKER",city:"LIVERPOOL",jerseyNumber:1,year:2024,overallRating:93,position:"GK" },
    { name:"EDERSON",city:"MANCHESTER",jerseyNumber:31,year:2024,overallRating:91,position:"GK" },
  ],
};

// ─── Position Eligibility ────────────────────────────────────────────────────

const FLEX_SLOTS = {
  football: { OL:["OT","OG","C"], DB:["CB","S"], RB:["RB","FB"], TE:["TE","FB"] },
};

export function canFillSlot(sport, slot, playerPosition) {
  const overrides = FLEX_SLOTS[sport];
  if (overrides && overrides[slot.toUpperCase()]) {
    return overrides[slot.toUpperCase()].includes(playerPosition.toUpperCase());
  }
  return slot.toUpperCase() === playerPosition.toUpperCase();
}

export function displayPosition(slot, player) {
  const flexSlots = ["OL","DB","RB","TE"];
  return flexSlots.includes(slot.toUpperCase()) ? player.position.toUpperCase() : slot.toUpperCase();
}

// ─── Player Generation ───────────────────────────────────────────────────────
// TODO: Replace with Firestore fetch when connecting real player data.

export function generatePlayers(sport, slot, excludedNames = new Set()) {
  const pool = MOCK_PLAYERS[sport] || [];
  const eligible = pool.filter(p => canFillSlot(sport, slot, p.position) && !excludedNames.has(p.name));
  const source = eligible.length >= 5
    ? eligible
    : pool.filter(p => canFillSlot(sport, slot, p.position));
  return [...source].sort(() => Math.random() - 0.5).slice(0, 5);
}

// ─── Draft Limit Helpers ─────────────────────────────────────────────────────
// Authenticated users: 1 draft per day per sport, enforced via Firestore (TODO).
// Guests: 1 draft per day total, enforced via localStorage as a best-effort limit.

const GUEST_LIMIT_KEY = "rosterable_guest_draft_date";

export function guestHasPlayedToday() {
  const stored = localStorage.getItem(GUEST_LIMIT_KEY);
  return stored === new Date().toDateString();
}

export function recordGuestDraftPlayed() {
  localStorage.setItem(GUEST_LIMIT_KEY, new Date().toDateString());
}

// ─── Active Draft Persistence ────────────────────────────────────────────────
// Saves an in-progress draft so a user can back out and resume the exact same
// players and progress. Candidates are locked per position: the 5 players on
// screen are saved the moment they appear, so leaving and coming back never
// re-rolls them. Scoped by owner (user uid or "guest") and sport, and stamped
// with the day — loading a draft started on a previous day discards it, which
// is the daily reset.

const ACTIVE_DRAFT_PREFIX = "rosterable_active_draft";

function activeDraftKey(ownerId, sportId) {
  return `${ACTIVE_DRAFT_PREFIX}_${ownerId}_${sportId}`;
}

// state shape:
// { positionIndex, draftedPlayers, candidates, hasUsedReroll, hasUsedReveal, revealedIndices }
export function saveActiveDraft(ownerId, sportId, state) {
  try {
    const payload = { ...state, date: new Date().toDateString() };
    localStorage.setItem(activeDraftKey(ownerId, sportId), JSON.stringify(payload));
  } catch {
    // localStorage unavailable (private mode / quota). Fail silently — the
    // draft just won't persist, matching the pre-persistence behavior.
  }
}

export function loadActiveDraft(ownerId, sportId) {
  try {
    const raw = localStorage.getItem(activeDraftKey(ownerId, sportId));
    if (!raw) return null;
    const saved = JSON.parse(raw);
    // Daily reset: anything not started today is stale — drop it.
    if (saved.date !== new Date().toDateString()) {
      localStorage.removeItem(activeDraftKey(ownerId, sportId));
      return null;
    }
    return saved;
  } catch {
    return null;
  }
}

export function clearActiveDraft(ownerId, sportId) {
  try {
    localStorage.removeItem(activeDraftKey(ownerId, sportId));
  } catch {
    // ignore
  }
}
